const foldTextProps = {
  line: {
    type: Number,
    default: 2
  }
};

export { foldTextProps };
//# sourceMappingURL=fold-text2.js.map
